import { render } from "./single-apply.vue?vue&type=template&id=63cfaaa4&scoped=true"
import script from "./single-apply.vue?vue&type=script&lang=js"
export * from "./single-apply.vue?vue&type=script&lang=js"

import "./single-apply.vue?vue&type=style&index=0&id=63cfaaa4&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cfaaa4"]])

export default __exports__